import Layout from '../../components/feature/Layout';
import AdvHero from './components/AdvHero';
import AdvDetailsSection01 from './components/AdvDetailsSection01';
import AdvDetailsSection02 from './components/AdvDetailsSection02';
import AdvDetailsSection03 from './components/AdvDetailsSection03';

export default function AdvantagesPage() {
  return (
    <Layout>
      <AdvHero />
      <AdvDetailsSection01 />
      <AdvDetailsSection02 />
      <AdvDetailsSection03 />
    </Layout>
  );
}
